import { useState } from "react";
import ContentLayout from "../../layout/contentLayout";
import {Grid,SelectChangeEvent,} from "@mui/material";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import StackKit from "@/shared/components/kit/stack";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import BoxKit from "@/shared/components/kit/box";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import { Content } from "./content";
import { numberSeparator } from "@/hooks/useThousandsSeparator";
import ContentWalletWithdrawalRequestReports from "./contentWalletWithdrawalRequestReports";
import {fetchListGetBalancePazirande,} from "@/api/merchant/request.get";
import { useQuery } from "@tanstack/react-query";
/**
 * WalletWithdrawalReports
 *
 * نمایش گزارش ها مرتبط با برداشت از کیف پول کاربران و موجودی نقدی.
 *
 * ویژگی‌ها:
 * - نمایش موجودی نقدی کیف پول با فرمت ریال و قابلیت بروزرسانی
 * - ارائه جزئیات درخواست‌های برداشت از کیف پول
 * - استفاده از ContentLayout برای ساختاردهی محتوای صفحات
 * - واکشی موجودی نقدی از سرور با استفاده از react-query و API fetchListGetBalancePazirande
 *
 * @returns JSX.Element
 */
const WalletWithdrawalReports = () => {
  const [value, setValue] = useState("موجودی نقدی : 5,000,000 ریال");

  const handleChange = (event: SelectChangeEvent) => {
    setValue(event.target.value);
  };

  const { data: dataWableCreditBalanceChart } = useQuery({
    queryKey: ["WithdrawRequest-data"],
    queryFn: fetchListGetBalancePazirande,
  });

  return (
    <>
      <ContentLayout
        icon={<AccountBalanceWalletOutlinedIcon />}
        title="گزارش ها برداشت از کیف پول"
        detailTitle={
          <Grid size={12} sx={{display: "flex",justifyContent: "space-between",alignItems: "center",gap: 2}}>
            <StackKit direction={{sm:"row",xs:'column'}} sx={{ width: "100%" }} alignItems={"center"} gap={3} marginBottom={'10px'}>
              <TypoGraphyKit variant="body1">موجودی نقدی کیف پول</TypoGraphyKit>
              <StackKit direction={{sm:"row",xs:'column'}} gap={3}>
                <TypoGraphyKit variant="h6">
                  {numberSeparator(dataWableCreditBalanceChart?.balance)} ریال
                </TypoGraphyKit>
              </StackKit>
            </StackKit>
          </Grid>
        }
        isContainerFluid
      >
        <Content />
      </ContentLayout>
      <ContentLayout icon={<AccountBalanceWalletOutlinedIcon />} title="گزارش ها درخواست برداشت از کیف پول" isContainerFluid>
        <ContentWalletWithdrawalRequestReports />
      </ContentLayout>
    </>
  );
};

export default WalletWithdrawalReports;
